import regionsCommunes from '@/assets/regionsCommunes.json';
import { normTxt } from '@/lib/searchText';

// The catalog of communes with their region, the only values the diligencia
// form sends as "Comuna · Región".
export const COMUNAS = regionsCommunes.regiones.flatMap((r) =>
  r.comunas.map((c) => ({ comuna: c, region: r.region })),
);

// Resuelve el texto del campo a una comuna de la lista: el texto exacto
// "Comuna · Región" o solo "Comuna" (sin tildes ni mayúsculas) cuando existe una
// única comuna con ese nombre. Cualquier otra cosa devuelve null: el API exige
// región y no se envía texto libre.
export function resolveComuna(text) {
  const [communePart, regionPart] = (text || '')
    .split('·')
    .map((s) => normTxt(s.trim()));
  if (!communePart) return null;
  const matches = COMUNAS.filter(
    (o) =>
      normTxt(o.comuna) === communePart &&
      (!regionPart || normTxt(o.region) === regionPart),
  );
  return matches.length === 1 ? matches[0] : null;
}

// Up to eight communes whose name or region contains what was typed.
export function matchComunas(text) {
  const q = normTxt(text);
  if (!q) return [];
  return COMUNAS.filter(
    (o) => normTxt(o.comuna).includes(q) || normTxt(o.region).includes(q),
  ).slice(0, 8);
}
